import { type UiConfigDto, updateInitialUiConfigDto } from '@/app/models/UiConfigDto';
import { type LoginAppearanceDto } from '@/app/models/LoginAppearanceDto';

import { LoginLayoutType } from '@/app/models/LoginLayoutType';
import { LoginBackgroundType } from '@/app/models/LoginBackgroundType';

export const getLoginMediaSettings = (
  layout: LoginLayoutType,
  backgroundType: LoginBackgroundType,
  backgroundSource = '/media/logos/login_page_image.png',
) => {
  const hasAutomaticImage = backgroundType === LoginBackgroundType.AUTO && layout !== LoginLayoutType.ESSENTIAL;
  const hasImage = backgroundType === LoginBackgroundType.IMAGE || hasAutomaticImage;
  const hasAnimation = backgroundType === LoginBackgroundType.LOTTIE;
  return { hasImage, hasAnimation, backgroundSource };
};

export const loginAppearanceFromConfig = (config: UiConfigDto): LoginAppearanceDto => {
  const preferences = updateInitialUiConfigDto(config);
  return {
    system_name: preferences.system_name,
    logo_url: preferences.login_logo?.public_url ?? preferences.logo?.public_url,
    layout: preferences.login_layout,
    theme: preferences.login_theme,
    primary_color: preferences.login_primary_color ?? preferences.primary_color,
    background_color: preferences.login_background_color,
    panel_color: preferences.login_panel_color ?? preferences.sidebar_color,
    background_type: preferences.login_background_type,
    background_media_url: preferences.login_background_media?.public_url,
    background_overlay_percent: preferences.login_background_overlay_percent,
    title: preferences.login_title,
    message: preferences.login_message,
    support_label: preferences.login_support_label,
    support_url: preferences.login_support_url,
    footer: preferences.login_footer,
  };
};

export const getDefaultLoginTexts = () => {
  const currentYear = new Date().getFullYear();
  return {
    title: 'Entrar na sua conta',
    message: 'Bem-vindo de volta.',
    support_label: 'Precisa de ajuda? Fale com o suporte',
    footer: `Powered by Uniolab · ${currentYear}`,
  };
};
